/**
 * Avatar Gradient Generator
 * Generates unique gradient classes based on username hash
 */

const GRADIENT_PALETTE = [
  'from-gray-800 via-gray-900 to-black',
  'from-zinc-800 via-zinc-900 to-black',
  'from-neutral-800 via-neutral-900 to-black',
  'from-slate-800 via-slate-900 to-black',
  'from-stone-800 via-stone-900 to-black',
  'from-gray-700 via-gray-800 to-gray-900',
  'from-zinc-700 via-zinc-800 to-zinc-900',
  'from-neutral-700 via-neutral-800 to-neutral-900',
  'from-slate-700 via-slate-800 to-slate-900',
  'from-stone-700 via-stone-800 to-stone-900',
] as const;

/**
 * Simple hash function for string
 */
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

/**
 * Get a unique gradient class based on username
 * @param username - User's username for hash generation
 * @returns Tailwind gradient class string
 */
export function getAvatarGradient(username: string): string {
  const hash = hashString(username || 'default');
  const index = hash % GRADIENT_PALETTE.length;
  return `bg-gradient-to-br ${GRADIENT_PALETTE[index]}`;
}
